.AddressLookup_AddressLookup_f6d333a{position:relative;display:inline-block}.listContainer_AddressLookup_f6d333a{border:2px solid green}